import { render, staticRenderFns } from "./BarChartHorizontal.vue?vue&type=template&id=52951429&"
import script from "./BarChartHorizontal.vue?vue&type=script&lang=js&"
export * from "./BarChartHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52951429')) {
      api.createRecord('52951429', component.options)
    } else {
      api.reload('52951429', component.options)
    }
    module.hot.accept("./BarChartHorizontal.vue?vue&type=template&id=52951429&", function () {
      api.rerender('52951429', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/v2charts/BarChartHorizontal.vue"
export default component.exports